import { APICore } from './apiCore'

const api = new APICore()

function getMediaSurveys (params) {
  const baseUrl = '/media-survey'
  return api.get(baseUrl, params)
}

function getMediaSurvey (id) {
  const baseUrl = `/media-survey/${id}`
  return api.get(baseUrl, {})
}

function addMediaSurvey (params) {
  const baseUrl = '/media-survey'
  return api.create(baseUrl, params)
}

function updateMediaSurvey (params) {
  const baseUrl = '/media-survey'
  return api.update(baseUrl, params)
}

function deleteMediaSurvey (params) {
  const baseUrl = '/media-survey'
  return api.delete(baseUrl, params)
}

export { getMediaSurveys, getMediaSurvey, addMediaSurvey, updateMediaSurvey, deleteMediaSurvey }
